import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { Headset } from "lucide-react";

import messages from "../../../assets/locale/messages";
import Card from "../../Card";
import {
  CREW_SIZE_SALES_EMAIL,
  fillTemplate,
} from "../../Events/Form/Steps/ChooseCrewSize/crewSizeUtils";
import SubscriptionPlanCard from "./SubscriptionPlanCard";

import "./Subscription.scss";

/**
 * Company Portal profile: the company's plan and the rates its events are billed on, read only
 * (PROLINE-4123). Only the Super Admin changes the plan, so the side card points to Yoram's team.
 */
const CompanySubscriptionSection = ({ company }) => {
  const lang = useSelector((state) => state.locale.lang);
  const t = messages[lang].companiesList.subscription.companyProfile;
  const plan = company?.subscription_plan;

  if (!plan) return null;

  return (
    <Card title={t.title}>
      <div className="company-subscription-section">
        <SubscriptionPlanCard
          subscription={{
            subscription_plan: plan,
            start_date: company.subscription_plan_assigned_at,
            renewal_date: company.subscription_renewal_date,
          }}
        />
        <div className="change-plan-contact-card">
          <span className="change-plan-contact-card__icon" aria-hidden="true">
            <Headset />
          </span>
          <div className="change-plan-contact-card__text">
            <Typography component="h3" className="text-heading-sm change-plan-contact-card__title">
              {t.changePlanTitle}
            </Typography>
            <Typography component="p" className="text-body-sm change-plan-contact-card__message">
              {fillTemplate(t.changePlanMessage, { email: CREW_SIZE_SALES_EMAIL })}
            </Typography>
          </div>
        </div>
      </div>
    </Card>
  );
};

CompanySubscriptionSection.propTypes = {
  /**
   * The company from `/companies/my_company`: `subscription_plan` (with `price_per_year` and its
   * rates), `subscription_plan_assigned_at` and `subscription_renewal_date`.
   */
  company: PropTypes.shape({
    subscription_plan: PropTypes.object,
    subscription_plan_assigned_at: PropTypes.string,
    subscription_renewal_date: PropTypes.string,
  }),
};

CompanySubscriptionSection.defaultProps = {
  company: null,
};

export default CompanySubscriptionSection;
